<template>
    
    <div class="row cart-left__body mt-1">
        <div class="col-4">
            <div class="row">
                <div class="col-3 p-0">
                    <div class="cart_img">
                        <!-- <img :src="`${$baseImageUrl}/banners/auth_bg.jpg`" /> -->
                        <img :src="cartItem.crop.image_url" v-if="cartItem.crop.image_url" />
                        <div v-else style="height: 100%"
                        class="font-lg font-bold d-flex align-items-center justify-content-center bg__inverse_light">
                            {{cartItem.crop.farm.farmer_name | initials}}
                        </div>
                    </div>
                </div>
                <div class="col-9 d-flex justify-content-center flex-column pr-0">
                    <h4 class="font-bold mb-2">{{cartItem.crop.name}}</h4>
                    <p>By <span class="font-bold">{{cartItem.crop.farm.farmer_name}}</span> </p>
                </div>
            </div>
        </div>
        <div class="col-3">
            <input type="number" class="form-control" v-model="quantity" step="any" />
            <div class="row">
                <a href="#" v-if="!updating" class="font-bold color__primary col-lg-4" @click.prevent="update">Update</a>
                <p class="font-bold color__grey_light col-lg-4" v-else>Updating</p>
                <a href="#" v-if="!loading" class="font-bold color__primary col-lg-8" @click.prevent="removeItem">Remove item</a>
                <p class="font-bold color__grey_light col-lg-4" v-else>Removing</p>
            </div>
        </div>
        <div class="col-2 font-bold d-flex align-items-center">
            <span class="naira mr-1"></span> {{perTon | formatNumber }}
        </div>
        <div class="col-3 font-bold d-flex align-items-center">
            <span class="naira mr-1"></span> {{amount | formatNumber }}
        </div>
    </div>
    
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
export default {
    props:['cartItem'],
    data() {
        return {
            quantity: '',
            loading: false,
            updating: false
        }
    },
    computed:{
        perTon() {
            return this.cartItem ? this.cartItem.crop.agg_kg_price / 0.001 : ''
        },
        amount() {
            return this.cartItem ? this.perTon * (this.cartItem.quantity / 1000) : ''
        }
    },
    methods: {
        ...mapActions('offtaker', { 
            toCart:'addToCart'
        }),
        setQuantity() {
            this.quantity = this.cartItem.quantity / 1000
        },
        ...mapMutations('offtaker', ['remove_item']),
        removeItem() {
            this.loading = true
            this.$http.delete(`cart_items/${this.cartItem.id}`)
            .then((res) => {
                this.$emit('refresh')
                this.remove_item(this.cartItem.id)
                this.$toastr.success('Item removed')
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.loading = false
            })
            
        },
        updateQty() {
           this.updating = true
           
            const formData = {
                crop_id: this.cartItem.crop_id,
                quantity: (this.quantity * 1000) - this.cartItem.quantity
            }
            this.$http.post('cart_items', formData)
            .then((res) => {
                this.getCartItems()
            })
            .catch((error) => {
                this.$toastr.error(error)
                this.updating = false
            })
        },
        update() {
            if(this.quantity === 0) {
                this.removeItem()
            } else {
                this.updateQty()
            }
        },
        getCartItems() {
          this.$http.get('cart_items')
          .then((response) => {
            this.toCart(response.data)
            this.$toastr.success('updated successfully')
          })
          .catch((error) => {
            this.$toastr.error(error)
          })
          .finally(() => {
            this.updating = false;
          })
        },
    },
    created() {
        // console.log(this.cartItem)
        // console.log('created')
    },
    mounted() {
        this.setQuantity()
    }
}
</script>

<style>

</style>